import { combineReducers, Reducer } from 'redux';
import {
    PortfolioSummaryActionType,
    PortfolioSummaryWidgetAction,
    PortfolioSummaryWidgetActionWithoutInitialise,
} from './actions';
import { portfolioSummaryConfigReducer } from './configuration/reducer';
import {
    initialPortfolioSummaryWidgetsState,
    initialPortfolioSummaryWidgetState,
    PortfolioSummaryWidgetsState,
    PortfolioSummaryWidgetState,
} from './PortfolioSummaryWidgetsState';
import { didNotReduce } from 'utils/redux/utils';
import {
    isSetConfigActionFor,
    WidgetActionPayload,
    WidgetActionType,
} from 'widgets/store/actions';
import { Action } from 'store/store';
import { portfolioSummaryComponentReducer } from './component/reducer';
import { WidgetType } from 'widgets/WidgetType';
import { PortfolioSummaryComponentState } from './component/PortfolioSummaryComponentState';
import { SetGridColumnWidthAction } from 'widgets/store/grid/columnWidth/actions';
import { PortfolioSummaryColumn } from 'widgets/portfolioSummary/grid/portfolioSummaryGridColumns';
import { WidgetSetConfigAction } from 'widgets/store/configuration/actions';
import { PortfolioSummaryConfigurationState } from './configuration/PortfolioSummaryConfigurationState';

const widgetStateReducer = combineReducers<PortfolioSummaryWidgetState>({
    component: portfolioSummaryComponentReducer as Reducer<
        PortfolioSummaryComponentState,
        SetGridColumnWidthAction<PortfolioSummaryColumn>
    >,

    config: portfolioSummaryConfigReducer,
});

export const portfolioSummaryReducer: Reducer<
    PortfolioSummaryWidgetsState,
    PortfolioSummaryWidgetAction
> = (
    state: PortfolioSummaryWidgetsState = initialPortfolioSummaryWidgetsState,
    action: Action<string, Partial<WidgetActionPayload> | undefined>
) => {
    if (action.type === WidgetActionType.WIDGET_RESET_INSTANCES_STATE) {
        return {};
    }

    if (!action.payload || !action.payload.widgetKey) {
        return state;
    }

    if (
        action.type !== PortfolioSummaryActionType.PORTFOLIO_SUMMARY_INITIALISE
    ) {
        const actionWithoutInitialise =
            action as PortfolioSummaryWidgetActionWithoutInitialise;
        if (
            actionWithoutInitialise.payload?.widgetType !==
            WidgetType.PORTFOLIO_SUMMARY
        ) {
            return state;
        }
    }

    const prevWidgetState =
        state[action.payload!.widgetKey] || initialPortfolioSummaryWidgetState;
    const nextWidgetState = widgetStateReducer(prevWidgetState, action);

    if (
        action.type !==
            PortfolioSummaryActionType.PORTFOLIO_SUMMARY_INITIALISE &&
        didNotReduce(prevWidgetState, nextWidgetState)
    ) {
        return state;
    }

    // When the aggregation field is changed (in config) we remove any drilldown (in component)...
    if (isSetConfigActionFor(WidgetType.PORTFOLIO_SUMMARY, action)) {
        const setConfigAction =
            action as WidgetSetConfigAction<PortfolioSummaryConfigurationState>;
        if (
            setConfigAction.payload!.configDelta.aggregationField &&
            nextWidgetState.component.drillDown &&
            nextWidgetState.component.drillDown.aggregationField !==
                setConfigAction.payload!.configDelta.aggregationField
        ) {
            delete nextWidgetState.component.drillDown;
        }
    }

    const nextState = { ...state };
    nextState[action.payload!.widgetKey] = nextWidgetState;
    return nextState;
};
